import styled from "styled-components";

export const Container = styled.header`
  width: 100%;
  background: #065a9c;
  color: white;
  display: flex;
  justify-content: center;
`;

export const Content = styled.div`
  width: 100%;
  height: 60px;
  max-width: 1000px;
  display: flex;
  align-items: center;
  padding-left: 20px;
`;
